<template>
    <a href="/emarket/cart/" title="Перейти в корзину">
        <i class="material-icons md-36 align-middle">
            shopping_cart
        </i>
        <span class="align-middle" v-html="cartAmount"></span>
    </a>
</template>

<script>
  export default {
    props: {
      'cartAmount' : {
        type: String,
        default: 0
      }
    },

    data () {
      return {
      }
    }
  }
</script>

<style scoped>

</style>